import { useMutation } from '@tanstack/react-query';
import { HcpActivationApi } from '../../../apis/HcpActivationApi/HcpActivationApi.ts';
import { CurrentUser } from '../../Login/CurrentUser.ts';

// Completing activation signs the HCP in, like a login: the response is the current user.
export function useCompleteHcpActivation() {
    return useMutation<CurrentUser, Error, { token: string; password: string }>({
        mutationFn: async ({ token, password }) => new CurrentUser(await HcpActivationApi.complete(token, password)),
        onSuccess: (currentUser) => {
            localStorage.setItem('currentUser', JSON.stringify(currentUser));
        },
    });
}
